import { Quaternion } from "@babylonjs/core/Maths/math.vector";
import { CreateLines } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { CreatePlane } from "@babylonjs/core/Meshes/Builders/planeBuilder";
import { Color3 } from "@babylonjs/core/Maths/math.color";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { TransformNode } from "@babylonjs/core/Meshes/transformNode";
import { VisibilityMode } from '../RoomManager';
import { EditWallOpening } from './../cmd/EditWallOpening';
import { WallOpeningInteractors } from './../tool/WallOpeningInteractors';
import { Util } from "../utils/Util";
import { CameraModeMask, CameraControl } from '@egr/wcf/modules/core/view/CameraControl';
import { ElementCategory, SceneElement, UndoOperation, BoundingBox } from '@egr/wcf/modules/core/mdl';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
import { PropertyValue, StringProperty, PropertyChangedResult, NumberProperty, LengthProperty, BoolProperty, Color3Property } from "@egr/wcf/modules/core/prop";
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
import { VECTOR3_ZERO, projectPointOnLine2ToRef, VECTOR3_Y } from "@egr/wcf/modules/core/utils/MathUtils";
import { newError, ERR_INVALID_STATE } from '@egr/wcf/modules/utils/error';
import { clone as arrClone } from '@egr/wcf/modules/utils/array';
import { deserializeVector2, serializeVector2 } from "@egr/wcf/modules/core/io";
import { eq, EPSILON, clamp, PI_DIV2 } from "@egr/wcf/modules/utils/math";
import { createOpeningGeometryType } from "./geo/OpeningGeometryHelper";
export class WallOpening extends SceneElement {
    constructor(pRoomManager, pType, pWidth = 0, pHeight = 0) {
        super(pRoomManager.app.model, new TransformNode("room:WallOpening_" + pType, pRoomManager.app.model.scene));
        this.mRoomManager = pRoomManager;
        this.mScene = pRoomManager.app.model.scene;
        this.mInteractors = new WallOpeningInteractors(this.mRoomManager, this);
        this.mIdStr = Util.HashString();
        this.mPosition = Vector2.Zero();
        this.mWall = null;
        this.mWallAttachData = null;
        this.mFloorOffset = 0.0;
        this.mHandleHeight = 0.9840;
        this.mMirrorVertical = false;
        this.mMirrorHorizontal = false;
        this.mType = pType;
        this.mHandlePos = new Vector3(0, 0, 0);
        this.mHingePos = new Vector3(0, 0, 0);
        this.mDoorSillColor = this.mRoomManager._wallColors[0];
        this.mMaterial_Sill = {};
        this.mMaterial_Sill.category = "";
        this.mMaterial_Sill.value = this.mRoomManager._wallColors[0];
        this.mMaterial_Sill.loadMatId = "";
        this.mMaterial_Sill.idAddOn = this.mIdStr;
        this.mMaterial_Sill.rotation = 0;
        this.mDoorLeafColor = this.mRoomManager._wallColors[0];
        this.mMaterial_Leaf = {};
        this.mMaterial_Leaf.category = "";
        this.mMaterial_Leaf.value = this.mRoomManager._wallColors[0];
        this.mMaterial_Leaf.loadMatId = "";
        this.mMaterial_Leaf.idAddOn = this.mIdStr;
        this.mMaterial_Leaf.rotation = 0;
        this.mDoorFrameColor = this.mRoomManager._wallColors[21];
        this.mMaterial_Frame = {};
        this.mMaterial_Frame.category = "";
        this.mMaterial_Frame.value = this.mRoomManager._wallColors[21];
        this.mMaterial_Frame.loadMatId = "";
        this.mMaterial_Frame.idAddOn = this.mIdStr;
        this.mMaterial_Frame.rotation = 0;
        this.mWindowSashColor = this.mRoomManager._wallColors[0];
        this.mMaterial_Sash = {};
        this.mMaterial_Sash.category = "";
        this.mMaterial_Sash.value = this.mRoomManager._wallColors[0];
        this.mMaterial_Sash.loadMatId = "";
        this.mMaterial_Sash.idAddOn = this.mIdStr;
        this.mMaterial_Sash.rotation = 0;
        this.mGeometryUpdateDepth = 0;
        this.mPendingGeometryUpdate = false;
        this.mHandleTansformationChange = true;
        this.mPendingTransformMatrix = null;
        this.misInteracting = false;
        //create geometry groups
        this.mNode.freezeWorldMatrix();
        this.m3dGroup = new TransformNode("group_3d", this.mScene);
        this.m3dGroup.parent = this.mNode;
        this.m3dGroup.freezeWorldMatrix();
        this.m2dGroup = this.m3dGroup.clone("group_2d", this.mNode);
        this.m2dGroup.position.y = 0.002;
        this.m2dGroup.freezeWorldMatrix();
        this.mOpeningParams = {};
        this.mRoomManager.checkMaterial(this.mMaterial_Sill);
        this.mRoomManager.checkMaterial(this.mMaterial_Leaf);
        this.mRoomManager.checkMaterial(this.mMaterial_Frame);
        this.mRoomManager.checkMaterial(this.mMaterial_Sash);
        //create geometry instance and setup intial parameters
        this.mGeometry = createOpeningGeometryType(this.mRoomManager, this, pType);
        if (this.mGeometry == null)
            throw new Error("Failed to create OpeningGeometry: " + pType);
        let tParams = this.mGeometry.getInitialParams();
        if (pWidth > 0)
            tParams.width = pWidth;
        if (pHeight > 0)
            tParams.height = pHeight;
        this.mWidth = tParams.width;
        this.mHeight = tParams.height;
        this.mScaling = new Vector2(1, 1);
        this.setFloorOffset(tParams.floorOffset, false);
        this.mwasCloned = false;
    }
    get width() {
        return (this.mWidth);
    }
    get isWallHidden() {
        if (this.mWall != null) {
            let tHidden = this.mWall.isHidden;
            return (tHidden);
        }
        return false;
    }
    get startPoint() {
        return (this.mStartPoint);
    }
    get endPoint() {
        return (this.mEndPoint);
    }
    get height() {
        return (this.mHeight);
    }
    get depth() {
        return (this.mWall != null ? this.mWall.thickness : 0.24);
    }
    get floorOffset() {
        return (this.mFloorOffset);
    }
    get handleHeight() {
        return (this.mHandleHeight);
    }
    get wasCloned() {
        return (this.mwasCloned);
    }
    get scaling() {
        return (this.mScaling);
    }
    get _WallAttachData() {
        return (this.mWallAttachData);
    }
    get mirrorVertical() {
        return (this.mMirrorVertical);
    }
    get mirrorHorizontal() {
        return (this.mMirrorHorizontal);
    }
    get wall() {
        return (this.mWall);
    }
    get geometry() {
        return (this.mGeometry);
    }
    get position() {
        return (this.mPosition);
    }
    get handlePosition() {
        return (this.mHandlePos);
    }
    get hingePosition() {
        return (this.mHingePos);
    }
    get category() {
        return (ElementCategory.FloorPlan);
    }
    get MaterialSet_Leaf() {
        return (this.mMaterial_Leaf);
    }
    get leafMaterialId() {
        return (this.mDoorLeafColor);
    }
    get MaterialSet_Sill() {
        return (this.mMaterial_Sill);
    }
    get sillMaterialId() {
        return (this.mDoorSillColor);
    }
    get MaterialSet_Frame() {
        return (this.mMaterial_Frame);
    }
    get frameMaterialId() {
        return (this.mDoorFrameColor);
    }
    get MaterialSet_Sash() {
        return (this.mMaterial_Sash);
    }
    get windowSashMaterialId() {
        return (this.mWindowSashColor);
    }
    get type() {
        return (this.mType);
    }
    get OpeningParams() {
        return (this.mOpeningParams);
    }
    dispose() {
        super.dispose();
        this.mWall = null;
        this.mInteractors.dispose();
    }
    canTranslate() {
        return (this.isSelected && this.mRoomManager.app.model.selection.length > 1);
    }
    canRotate() {
        return (this.isSelected && this.mRoomManager.app.model.selection.length > 1);
    }
    showInteractors(pShow) {
        this.mInteractors.showInteractors(pShow);
    }
    clone(pNewParent) {
        if (this.mWall !== null && this.mWall.isSelected)
            return (null);
        let tClone = new WallOpening(this.mRoomManager, this.mGeometry.getType());
        this.cloneOpeningParams(this.mOpeningParams, tClone.mOpeningParams);
        tClone.mwasCloned = true;
        tClone.beginGeometryUpdate();
        tClone.node.parent = pNewParent != null ? pNewParent : null;
        tClone.copyDataFrom(this);
        let tWall = tClone.wall;
        if (tWall == null) {
            tClone.dispose();
            return (null);
        }
        let tcheck = tWall.checkInsertWallElement(tClone, true, null, this.position, true);
        if (!tcheck) {
            tWall._removeOpening(tClone);
            tClone.dispose();
            this.mRoomManager.eventNotEnoughWallSpaceLeft.trigger(this.mRoomManager);
            return (null);
        }
        tClone.updateGeometry();
        tClone.endGeometryUpdate();
        return (tClone);
    }
    saveUndoData(pOperation) {
        return (this._saveUndoData());
    }
    loadUndoData(pOperation, pUndoData) {
        this._loadUndoData(pUndoData);
        if (pOperation === UndoOperation.Transform)
            this.mRoomManager._removeTransformedElement(this);
    }
    isSelectionHighlightEnabled() {
        let tSel = this.mRoomManager.app.model.selection;
        if (tSel.length !== 1)
            return (true);
        return (true);
    }
    getMaterialofSet(pMaterialSet) {
        let tSetMaterial = this.mRoomManager.getMaterialId(pMaterialSet);
        let tMat = null;
        if (tSetMaterial.indexOf(this.mRoomManager.materialSplitStr) === -1) {
            tMat = this.mRoomManager._getWallColorMaterial(pMaterialSet.value);
        }
        else {
            tMat = this.mRoomManager.MatManager.getMaterial(tSetMaterial);
        }
        return (tMat);
    }
    getSelectionHighlightBoundingBox() {
        let tHW = this.mWidth * 0.5 + 0.03;
        let tHD = this.depth * 0.5;
        let tHeight = this.mFloorOffset + this.mHeight + 0.03;
        if (this.mRoomManager.visibilityMode === VisibilityMode.Show2d)
            tHeight = 0.001;
        let tBounds = new BoundingBox(new Vector3(-tHW, 0.0, -tHD), new Vector3(tHW, tHeight, tHD));
        return (tBounds);
    }
    getPropertyClasses() {
        return (Promise.resolve(this.mRoomManager.PropClasses));
    }
    getProperties() {
        // tslint:disable-next-line:cyclomatic-complexity
        let tPromise = super.getProperties().then((pProperties) => {
            let tProperties = pProperties;
            if (tProperties == null)
                tProperties = new Array();
            //door type
            if (this.mType === "Door") {
                let tDoorTypesList = new Array();
                for (let tDoorType in WallOpening.DoorTypes) {
                    if (typeof tDoorType === 'string') {
                        tDoorTypesList.push(this.mRoomManager._getDoorTypesPropValue(tDoorType));
                    }
                }
                let tDoorTypeProp = new StringProperty(this, WallOpening.PROP_KEY_DOOR_TYPE, this.mRoomManager.resources.propertyDoorType);
                tDoorTypeProp.class = "base";
                tDoorTypeProp.choiceList = true;
                tDoorTypeProp.getChoices = () => Promise.resolve(tDoorTypesList);
                tDoorTypeProp.getValue = () => this.mRoomManager._getDoorTypesPropValue(this.mOpeningParams.doorType);
                tDoorTypeProp.setValue = (pValue) => {
                    let tValue = StringProperty.ConvertValueToString(pValue);
                    this.setDoorType(tValue, this.mOpeningParams.doorTypeDouble);
                    return (Promise.resolve(PropertyChangedResult.Value));
                };
                tDoorTypeProp.visible = true;
                tProperties.push(tDoorTypeProp);
                let tDoorLeafsCount = this.mRoomManager._getNumberListPropValue(2);
                let tDoorTypeDoubleProp = new NumberProperty(this, WallOpening.PROP_KEY_DOOR_LEAF_COUNT, this.mRoomManager.resources.propertyDoorLeafCount);
                tDoorTypeDoubleProp.class = "base";
                tDoorTypeDoubleProp.choiceList = true;
                tDoorTypeDoubleProp.getChoices = () => Promise.resolve(tDoorLeafsCount);
                tDoorTypeDoubleProp.getValue = () => this.mRoomManager.__getNumberofBool(this.mOpeningParams.doorTypeDouble);
                tDoorTypeDoubleProp.setValue = (pValue) => {
                    let tValue = NumberProperty.ConvertValueToNumber(pValue) === 1 ? false : true;
                    this.setDoorType(this.mOpeningParams.doorType, tValue);
                    return (Promise.resolve(PropertyChangedResult.Value));
                };
                tDoorTypeDoubleProp.visible = true;
                tProperties.push(tDoorTypeDoubleProp);
            }
            //width
            let tWidthProp = new LengthProperty(this, WallOpening.PROP_KEY_WIDTH, this.mRoomManager.resources.propertyWidth);
            tWidthProp.class = "base";
            tWidthProp.getValue = () => new PropertyValue(this.mWidth);
            tWidthProp.setValue = (pValue) => {
                let tValue = LengthProperty.ConvertValueToNumber(pValue);
                if (tValue != null && this.setWidth(tValue))
                    return (Promise.resolve(PropertyChangedResult.Value));
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tWidthProp);
            //height
            let tHeightProp = new LengthProperty(this, WallOpening.PROP_KEY_HEIGHT, this.mRoomManager.resources.propertyHeight);
            tHeightProp.class = "base";
            tHeightProp.getValue = () => new PropertyValue(this.mHeight);
            tHeightProp.setValue = (pValue) => {
                let tValue = LengthProperty.ConvertValueToNumber(pValue);
                if (tValue != null && this.setHeight(tValue))
                    return (Promise.resolve(PropertyChangedResult.Value));
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tHeightProp);
            //floor offset
            let tFloorOffsetProp = new LengthProperty(this, WallOpening.PROP_KEY_FLOOROFFSET, this.mRoomManager.resources.propertyParapet);
            tFloorOffsetProp.class = "base";
            tFloorOffsetProp.getValue = () => new PropertyValue(this.mFloorOffset);
            tFloorOffsetProp.setValue = (pValue) => {
                let tValue = LengthProperty.ConvertValueToNumber(pValue);
                if (tValue != null) {
                    this.setFloorOffset(tValue, true);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tFloorOffsetProp);
            //handle height
            let tHandleHeightProp = new LengthProperty(this, WallOpening.PROP_KEY_HANDLEHEIGHT, this.mRoomManager.resources.propertyHandleHeight);
            tHandleHeightProp.class = "base";
            tHandleHeightProp.getValue = () => new PropertyValue(this.mHandleHeight);
            tHandleHeightProp.setValue = (pValue) => {
                let tValue = LengthProperty.ConvertValueToNumber(pValue);
                if (tValue != null) {
                    this.setHandleHeight(tValue);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            switch (this.mType) {
                case "Window":
                case "WindowDouble":
                case "Opening":
                case "GlassFront":
                    tHandleHeightProp.visible = false;
                    break;
                default:
                    tHandleHeightProp.visible = true;
            }
            tProperties.push(tHandleHeightProp);
            //opening angle
            let topeningAngle = this.mOpeningParams.openingAngle !== undefined ? this.mOpeningParams.openingAngle : 0;
            let tOpeningAngleProp = new NumberProperty(this, WallOpening.PROP_KEY_OPENINGANGLE, this.mRoomManager.resources.propertyOpeningAngle);
            tOpeningAngleProp.class = "base";
            tOpeningAngleProp.getValue = () => new PropertyValue(topeningAngle);
            tOpeningAngleProp.setValue = (pValue) => {
                let tValue = LengthProperty.ConvertValueToNumber(pValue);
                if (tValue != null) {
                    this.setOpeningAngle(tValue, true);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            switch (this.mType) {
                case "Door":
                case "GlassDoor":
                case "GlassInlayDoor":
                case "GlassInlayDoubleDoor":
                case "DoubleDoor":
                case "GlassDoubleDoor":
                    tOpeningAngleProp.visible = true;
                    break;
                default:
                    tOpeningAngleProp.visible = false;
            }
            tProperties.push(tOpeningAngleProp);
            let tYesNoChoices = new Array();
            for (let tYesNo of this.mRoomManager._YesNo)
                tYesNoChoices.push(this.mRoomManager._getYesNoPropValue(tYesNo));
            //fanlight active
            let tFanlightEnabledProp = new BoolProperty(this, WallOpening.PROP_KEY_FANLIGHTENABLED, this.mRoomManager.resources.propertyEnabled);
            tFanlightEnabledProp.class = "fanlight";
            tFanlightEnabledProp.choiceList = true;
            tFanlightEnabledProp.getChoices = () => Promise.resolve(tYesNoChoices);
            tFanlightEnabledProp.getValue = () => this.mRoomManager._getYesNoPropValue(this.mOpeningParams.fanlight);
            tFanlightEnabledProp.setValue = (pValue) => {
                let tValue = BoolProperty.ConvertValueToBool(pValue);
                this.setFanLightEnabled(tValue);
                return (Promise.resolve(PropertyChangedResult.Value));
            };
            switch (this.mType) {
                case "Door":
                case "DoubleDoor":
                case "GlassDoor":
                case "GlassDoubleDoor":
                    tFanlightEnabledProp.visible = true;
                    break;
                default:
                    tFanlightEnabledProp.visible = false;
            }
            tProperties.push(tFanlightEnabledProp);
            //fanlight height
            let tFanlightProp = new LengthProperty(this, WallOpening.PROP_KEY_FANLIGHTHEIGHT, this.mRoomManager.resources.propertyHeight);
            tFanlightProp.class = "fanlight";
            tFanlightProp.getValue = () => new PropertyValue(this.mOpeningParams.fanlightHeight);
            tFanlightProp.setValue = (pValue) => {
                let tValue = LengthProperty.ConvertValueToNumber(pValue);
                if (tValue != null) {
                    this.setFanLightHeight(tValue);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tFanlightProp.visible = this.mOpeningParams.fanlight;
            tProperties.push(tFanlightProp);
            // category list
            let tColorChoices = new Array();
            for (let tCol of this.mRoomManager._wallColors)
                tColorChoices.push(this.mRoomManager._getWallColorPropValue(tCol));
            let tType = this.mType.toString().toLocaleLowerCase();
            if (this.mType === "Door" || this.mType === "DoubleDoor" ||
                this.mType === "GlassInlayDoor" || this.mType === "GlassInlayDoubleDoor")
                tType = "door";
            let tMaterialCategory = this.mRoomManager.getMaterial_Categories(tType);
            //material category: leaf
            let tMatCategory_Leaf_Prop = new NumberProperty(this, WallOpening.PROP_KEY_MATCAT_LEAF, this.mRoomManager.resources.propertyMaterialCategory);
            tMatCategory_Leaf_Prop.class = "doorleaf";
            tMatCategory_Leaf_Prop.choiceList = true;
            tMatCategory_Leaf_Prop.getChoices = () => Promise.resolve(tMaterialCategory);
            tMatCategory_Leaf_Prop.getValue = () => this.mRoomManager.getMaterialCategoryValue(tMaterialCategory, this.mMaterial_Leaf);
            tMatCategory_Leaf_Prop.setValue = (pValue) => {
                if (pValue != null) {
                    this.setMaterialCategory(StringProperty.ConvertValueToString(pValue), undefined, this.mMaterial_Leaf);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tMatCategory_Leaf_Prop.visible = true;
            switch (this.mType) {
                case "Door":
                    if (this.mOpeningParams.doorType === WallOpening.DoorTypes.glass) {
                        tMatCategory_Leaf_Prop.visible = false;
                    }
                    break;
                default:
                    tMatCategory_Leaf_Prop.visible = false;
            }
            tProperties.push(tMatCategory_Leaf_Prop);
            let tpropTitle_ColMat = this.mMaterial_Sill.category === "" ? this.mRoomManager.resources.propertyColor :
                this.mRoomManager.resources.propertyMaterial;
            //color/material: leaf
            tpropTitle_ColMat = this.mMaterial_Leaf.category === "" ? this.mRoomManager.resources.propertyColor :
                this.mRoomManager.resources.propertyMaterial;
            let tColMat_Leaf_Prop;
            if (this.mMaterial_Leaf.category === "" || this.mMaterial_Leaf.category === "color") {
                tColMat_Leaf_Prop = new Color3Property(this, WallOpening.PROP_KEY_COLOR_LEAF, tpropTitle_ColMat);
            }
            else {
                tColMat_Leaf_Prop = new StringProperty(this, WallOpening.PROP_KEY_COLOR_LEAF, tpropTitle_ColMat);
            }
            tColMat_Leaf_Prop.class = "doorleaf";
            tColMat_Leaf_Prop.choiceList = true;
            let tMatList2 = this.mRoomManager.getMaterialsOfCategory(this.mMaterial_Leaf, tType);
            tColMat_Leaf_Prop.getChoices = () => Promise.resolve(tMatList2);
            tColMat_Leaf_Prop.getValue = () => this.mRoomManager.getMaterialValue(this.mMaterial_Leaf, tMatList2);
            tColMat_Leaf_Prop.setValue = (pValue) => {
                let tValue = StringProperty.ConvertValueToString(pValue);
                if (tValue != null) {
                    this.setMaterial_Leaf(tValue, this.mMaterial_Leaf);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tColMat_Leaf_Prop.visible = true;
            switch (this.mType) {
                case "Door":
                    if (this.mOpeningParams.doorType === WallOpening.DoorTypes.glass) {
                        tColMat_Leaf_Prop.visible = false;
                    }
                    break;
                default:
                    tColMat_Leaf_Prop.visible = false;
            }
            tProperties.push(tColMat_Leaf_Prop);
            //material category: frame
            let tMatCategory_Frame_Prop = new NumberProperty(this, WallOpening.PROP_KEY_MATCAT_FRAME, this.mRoomManager.resources.propertyMaterialCategory);
            tMatCategory_Frame_Prop.class = "doorframe";
            tMatCategory_Frame_Prop.choiceList = true;
            tMatCategory_Frame_Prop.getChoices = () => Promise.resolve(tMaterialCategory);
            tMatCategory_Frame_Prop.getValue = () => this.mRoomManager.getMaterialCategoryValue(tMaterialCategory, this.mMaterial_Frame);
            tMatCategory_Frame_Prop.setValue = (pValue) => {
                if (pValue != null) {
                    this.setMaterialCategory(StringProperty.ConvertValueToString(pValue), undefined, this.mMaterial_Frame);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            switch (this.mType) {
                case "Window":
                case "WindowDouble":
                case "Opening":
                    tMatCategory_Frame_Prop.visible = false;
                    break;
                default:
                    tMatCategory_Frame_Prop.visible = true;
            }
            tProperties.push(tMatCategory_Frame_Prop);
            //color/material: frame
            tpropTitle_ColMat = this.mMaterial_Frame.category === "" ? this.mRoomManager.resources.propertyColor :
                this.mRoomManager.resources.propertyMaterial;
            let tColMat_Frame_Prop;
            if (this.mMaterial_Frame.category === "" || this.mMaterial_Frame.category === "color") {
                tColMat_Frame_Prop = new Color3Property(this, WallOpening.PROP_KEY_COLOR_FRAME, tpropTitle_ColMat);
            }
            else {
                tColMat_Frame_Prop = new StringProperty(this, WallOpening.PROP_KEY_COLOR_FRAME, tpropTitle_ColMat);
            }
            tColMat_Frame_Prop.class = "doorframe";
            tColMat_Frame_Prop.choiceList = true;
            let tMatList3 = this.mRoomManager.getMaterialsOfCategory(this.mMaterial_Frame, tType);
            tColMat_Frame_Prop.getChoices = () => Promise.resolve(tMatList3);
            tColMat_Frame_Prop.getValue = () => this.mRoomManager.getMaterialValue(this.mMaterial_Frame, tMatList3);
            tColMat_Frame_Prop.setValue = (pValue) => {
                let tValue = StringProperty.ConvertValueToString(pValue);
                if (tValue != null) {
                    this.setMaterial_Frame(tValue, this.mMaterial_Frame);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            switch (this.mType) {
                case "Window":
                case "WindowDouble":
                case "Opening":
                    tColMat_Frame_Prop.visible = false;
                    break;
                default:
                    tColMat_Frame_Prop.visible = true;
            }
            tProperties.push(tColMat_Frame_Prop);
            //material category: sill
            let tMatCategory_Sill_Prop = new NumberProperty(this, WallOpening.PROP_KEY_MATCAT_SILL, this.mRoomManager.resources.propertyMaterialCategory);
            tMatCategory_Sill_Prop.class = "doorsill";
            tMatCategory_Sill_Prop.choiceList = true;
            tMatCategory_Sill_Prop.getChoices = () => Promise.resolve(tMaterialCategory);
            tMatCategory_Sill_Prop.getValue = () => this.mRoomManager.getMaterialCategoryValue(tMaterialCategory, this.mMaterial_Sill);
            tMatCategory_Sill_Prop.setValue = (pValue) => {
                if (pValue != null) {
                    this.setMaterialCategory(StringProperty.ConvertValueToString(pValue), undefined, this.mMaterial_Sill);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            switch (this.mType) {
                case "Window":
                case "WindowDouble":
                    tMatCategory_Sill_Prop.visible = false;
                    break;
                default:
                    tMatCategory_Sill_Prop.visible = true;
            }
            tProperties.push(tMatCategory_Sill_Prop);
            //color/material: sill
            let tColMat_Sill_Prop;
            if (this.mMaterial_Sill.category === "" || this.mMaterial_Sill.category === "color") {
                tColMat_Sill_Prop = new Color3Property(this, WallOpening.PROP_KEY_COLOR_SILL, tpropTitle_ColMat);
            }
            else {
                tColMat_Sill_Prop = new StringProperty(this, WallOpening.PROP_KEY_COLOR_SILL, tpropTitle_ColMat);
            }
            tColMat_Sill_Prop.class = "doorsill";
            tColMat_Sill_Prop.choiceList = true;
            let tMatList1 = this.mRoomManager.getMaterialsOfCategory(this.mMaterial_Sill, tType);
            tColMat_Sill_Prop.getChoices = () => Promise.resolve(tMatList1);
            tColMat_Sill_Prop.getValue = () => this.mRoomManager.getMaterialValue(this.mMaterial_Sill, tMatList1);
            tColMat_Sill_Prop.setValue = (pValue) => {
                let tValue = StringProperty.ConvertValueToString(pValue);
                if (tValue != null) {
                    this.setMaterial_Sill(tValue, this.mMaterial_Sill);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            switch (this.mType) {
                case "Window":
                case "WindowDouble":
                    tColMat_Sill_Prop.visible = false;
                    break;
                default:
                    tColMat_Sill_Prop.visible = true;
            }
            tProperties.push(tColMat_Sill_Prop);
            // ----------------------- window sash
            //material category: window sash
            let tMatCategory_WindowSash_Prop = new NumberProperty(this, WallOpening.PROP_KEY_MATCAT_WINDOWSASH, this.mRoomManager.resources.propertyMaterialCategory);
            tMatCategory_WindowSash_Prop.class = "sash";
            tMatCategory_WindowSash_Prop.choiceList = true;
            tMatCategory_WindowSash_Prop.getChoices = () => Promise.resolve(tMaterialCategory);
            tMatCategory_WindowSash_Prop.getValue = () => this.mRoomManager.getMaterialCategoryValue(tMaterialCategory, this.mMaterial_Sash);
            tMatCategory_WindowSash_Prop.setValue = (pValue) => {
                if (pValue != null) {
                    this.setMaterialCategory(StringProperty.ConvertValueToString(pValue), undefined, this.mMaterial_Sash);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            switch (this.mType) {
                case "Window":
                case "WindowDouble":
                    tMatCategory_WindowSash_Prop.visible = true;
                    break;
                default:
                    tMatCategory_WindowSash_Prop.visible = false;
            }
            tProperties.push(tMatCategory_WindowSash_Prop);
            //color/material: window sash
            tpropTitle_ColMat = this.mMaterial_Sash.category === "" ? this.mRoomManager.resources.propertyColor :
                this.mRoomManager.resources.propertyMaterial;
            let tColMat_WindowSash_Prop;
            if (this.mMaterial_Sash.category === "" || this.mMaterial_Sash.category === "color") {
                tColMat_WindowSash_Prop = new Color3Property(this, WallOpening.PROP_KEY_COLOR_WINDOWSASH, tpropTitle_ColMat);
            }
            else {
                tColMat_WindowSash_Prop = new StringProperty(this, WallOpening.PROP_KEY_COLOR_WINDOWSASH, tpropTitle_ColMat);
            }
            tColMat_WindowSash_Prop.class = "sash";
            tColMat_WindowSash_Prop.choiceList = true;
            let tMatList4 = this.mRoomManager.getMaterialsOfCategory(this.mMaterial_Sash, tType);
            tColMat_WindowSash_Prop.getChoices = () => Promise.resolve(tMatList4);
            tColMat_WindowSash_Prop.getValue = () => this.mRoomManager.getMaterialValue(this.mMaterial_Sash, tMatList4);
            tColMat_WindowSash_Prop.setValue = (pValue) => {
                let tValue = StringProperty.ConvertValueToString(pValue);
                if (tValue != null) {
                    this.setMaterial_Frame(tValue, this.mMaterial_Sash);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            switch (this.mType) {
                case "Window":
                case "WindowDouble":
                    tColMat_WindowSash_Prop.visible = true;
                    break;
                default:
                    tColMat_WindowSash_Prop.visible = false;
            }
            tProperties.push(tColMat_WindowSash_Prop);
            //add geometry properties
            let tGeomProps = this.mGeometry.getProperties();
            if (tGeomProps != null) {
                for (let tProp of tGeomProps)
                    tProperties.push(tProp);
            }
            return (tProperties);
        });
        return (tPromise);
    }
    beginInteracting() {
        if (!this.misInteracting) {
            this.misInteracting = true;
            if (this.mWall != null)
                this.mWall.beginOpeningInteraction();
            this.updateGeometry();
        }
    }
    endInteracting() {
        if (this.misInteracting) {
            this.misInteracting = false;
            if (this.mWall != null)
                this.mWall.endOpeningInteraction();
            this.updateGeometry();
        }
    }
    setPosition(pNewPos, pNotifyWall = true) {
        if (pNewPos == null || this.mWall == null)
            return (false);
        // avoid moving opening across start/end point
        let tdir = this.mWall.wallDirection.clone();
        let tstartPoint = this.mWall.startPoint.add(tdir.scale(this.mWidth * 0.5));
        let tendPoint = this.mWall.endPoint.subtract(tdir.scale(this.mWidth * 0.5));
        projectPointOnLine2ToRef(pNewPos, tstartPoint, tendPoint, true, this.mPosition);
        this.mStartPoint = this.mPosition.subtract(tdir.scale(this.mWidth * 0.5));
        this.mEndPoint = this.mPosition.add(tdir.scale(this.mWidth * 0.5));
        this.updateWallAttachData();
        this.updateMatrix();
        if (pNotifyWall)
            this.mWall.updateGeometry();
        return (true);
    }
    setHandlePos(pPos) {
        this.mHandlePos = pPos;
        this.mHingePos.y = this.mHandlePos.y;
    }
    setHingePos(pPos) {
        this.mHingePos = pPos;
    }
    setType(pType) {
        this.mType = pType;
    }
    attachToWall(pWall, pInsertPos) {
        if (pWall == null || pWall === this.mWall)
            return;
        if (this.mWall != null) {
            this.mWall._removeOpening(this);
            this.mWall = null;
        }
        this.mWall = pWall;
        if (pInsertPos != null)
            this.setPosition(pInsertPos, false);
        this.mWall._addOpening(this);
    }
    updateAttachedPosition(pNotifyWall = true) {
        if (this.mNode == null || this.mWall == null || this.mWallAttachData == null)
            return;
        let tWallLength = Vector2.Distance(this.mWall.startPoint, this.mWall.endPoint);
        let tWallDir = this.mWall.endPoint.subtract(this.mWall.startPoint).normalize();
        if (!this.mWall.startPoint.equalsWithEpsilon(this.mWallAttachData.start, EPSILON)) {
            if (this.mWallAttachData.distanceEnd > tWallLength)
                this.mWallAttachData.distanceEnd = tWallLength;
            tWallDir.scaleInPlace(this.mWallAttachData.distanceEnd);
            this.mPosition = this.mWall.endPoint.subtract(tWallDir);
        }
        else {
            if (this.mWallAttachData.distanceStart > tWallLength)
                this.mWallAttachData.distanceStart = tWallLength;
            tWallDir.scaleInPlace(this.mWallAttachData.distanceStart);
            this.mPosition = this.mWall.startPoint.add(tWallDir);
        }
        this.updateWallAttachData();
        this.updateMatrix();
        let tdir = this.mWall.wallDirection.clone();
        this.mStartPoint = this.mPosition.subtract(tdir.scale(this.mWidth * 0.5));
        this.mEndPoint = this.mPosition.add(tdir.scale(this.mWidth * 0.5));
        if (pNotifyWall)
            this.mWall.updateGeometry();
    }
    mirror() {
        let tCmd = new EditWallOpening(this.mRoomManager, this);
        if (this.geometry.canMirrorV && this.geometry.canMirrorH) {
            let tH = this.mirrorHorizontal;
            let tV = this.mirrorVertical;
            if (tH && tV)
                this.setMirrorVertical(false);
            else if (tH)
                this.setMirrorHorizontal(false);
            else if (tV)
                this.setMirrorHorizontal(true);
            else
                this.setMirrorVertical(true);
        }
        else if (this.geometry.canMirrorV) {
            this.setMirrorVertical(!this.mirrorVertical);
        }
        else if (this.geometry.canMirrorH) {
            this.setMirrorHorizontal(!this.mirrorHorizontal);
        }
        void this.mRoomManager.app.commands.executeCommand(tCmd);
    }
    setMirrorVertical(pMirror) {
        if (pMirror === this.mMirrorVertical)
            return;
        this.mMirrorVertical = pMirror;
        this.updateGeometry();
    }
    setMirrorHorizontal(pMirror) {
        if (pMirror === this.mMirrorHorizontal)
            return;
        this.mMirrorHorizontal = pMirror;
        this.updateGeometry();
    }
    setWidth(pValue, pOnlySetValue = false) {
        let tValue = clamp(pValue, 0.01, 100.0);
        if (pOnlySetValue) {
            this.mWidth = pValue;
            return (true);
        }
        if (this.mWall == null || this.mWall.getWallLengthBase() < pValue || eq(this.mWidth, tValue))
            return (false);
        if (tValue < this.mOpeningParams.minWidth)
            tValue = this.mOpeningParams.minWidth;
        this.mWidth = tValue;
        this.beginChange();
        this.updateGeometry();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        this.notifyChange(ElementChangedFlags.Properties);
        this.endChange();
        if (this.mWall != null)
            this.mWall.updateGeometry();
        this.mRoomManager.contentChanged();
        return (true);
    }
    setStartPoint(pPos) {
        let tWidth = Vector2.Distance(pPos, this.mEndPoint);
        if (tWidth < this.mOpeningParams.minWidth)
            return (false);
        this.mStartPoint = pPos;
        this.mWidth = tWidth;
        this.mPosition = Vector2.Center(this.mStartPoint, this.mEndPoint);
        this.setPosition(this.mPosition);
        this.beginChange();
        this.updateGeometry();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        this.notifyChange(ElementChangedFlags.Properties);
        this.endChange();
        if (this.mWall != null)
            this.mWall.updateGeometry();
        this.mRoomManager.contentChanged();
        return (true);
    }
    setEndPoint(pPos) {
        let tWidth = Vector2.Distance(this.mStartPoint, pPos);
        if (tWidth < this.mOpeningParams.minWidth)
            return (false);
        this.mEndPoint = pPos;
        this.mWidth = tWidth;
        this.mPosition = Vector2.Center(this.mStartPoint, this.mEndPoint);
        this.setPosition(this.mPosition);
        this.beginChange();
        this.updateGeometry();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        this.notifyChange(ElementChangedFlags.Properties);
        this.endChange();
        if (this.mWall != null)
            this.mWall.updateGeometry();
        this.mRoomManager.contentChanged();
        return (true);
    }
    beginGeometryUpdate() {
        this.mGeometryUpdateDepth++;
    }
    endGeometryUpdate() {
        this.mGeometryUpdateDepth--;
        if (this.mGeometryUpdateDepth <= 0) {
            this.mGeometryUpdateDepth = 0;
            if (this.mPendingGeometryUpdate)
                this.updateGeometry();
        }
    }
    updateGeometry() {
        if (this.mGeometryUpdateDepth > 0) {
            this.mPendingGeometryUpdate = true;
            return;
        }
        this.mPendingGeometryUpdate = false;
        let tScaleFactor = this.getScreenScaleFactor();
        let tscaling = tScaleFactor * (1 / 10);
        this.mScaling.x = this.width / tscaling;
        this.mScaling.y = this.depth / tscaling;
        this.update2dGeometry();
        this.update3dGeometry();
        this.notifyChange(ElementChangedFlags.BoundingBox);
    }
    getCSGCutObject() {
        if (this.mWall == null)
            throw newError(ERR_INVALID_STATE, "wall is null");
        let tHW = this.mWidth * 0.5;
        let tHH = this.mHeight * 0.5;
        let tHD = (this.depth + 0.002) * 0.5; //add 1 mm offset on both sides
        let tCube = CSG.cube({
            corner1: [-tHW, -tHH, -tHD],
            corner2: [tHW, tHH, tHD]
        });
        //translate
        let tPos = Vector3.TransformCoordinates(this.mNode.position, this.mWall.transformInverted);
        tPos.y = this.mHeight * 0.5 + this.mFloorOffset;
        tCube = tCube.translate([tPos.x, tPos.y, tPos.z]);
        //TODO: use material of attached wall side ?
        /*if (this.mAttachedStructure != null && this.mAttachedEdgeId != null) {
            let tIndex = this.mAttachedStructure.polygon.getPointById(this.mAttachedEdgeId);
            if (tIndex != null) {
                let tMaterial = this.mAttachedStructure.polygon.pointsData[tIndex].material;
                let tShared = new CsgUtils.PolygonShared(tMaterial);
                for (let tPoly of tCube.polygons)
                    tPoly.shared = tShared;
            }
        }*/
        return (tCube);
    }
    getEdge(pEdge, pLocalCoords) {
        let tV;
        switch (pEdge) {
            case 0:
                tV = new Vector2(-this.mWidth * 0.5, -this.depth * 0.5);
                break;
            case 1:
                tV = new Vector2(this.mWidth * 0.5, -this.depth * 0.5);
                break;
            case 2:
                tV = new Vector2(this.mWidth * 0.5, this.depth * 0.5);
                break;
            default: //3
                tV = new Vector2(-this.mWidth * 0.5, this.depth * 0.5);
                break;
        }
        if (!pLocalCoords) {
            let tV3d = Util.to3d(tV);
            Vector3.TransformCoordinatesToRef(tV3d, this.transform, tV3d);
            tV = Util.to2d(tV3d);
        }
        return (tV);
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _serializeIOData(pContext) {
        let tIOOpening = {};
        tIOOpening.type = this.mGeometry.getType();
        tIOOpening.width = this.mWidth;
        tIOOpening.height = this.mHeight;
        tIOOpening.floorOffset = this.mFloorOffset;
        if (this.mMirrorVertical)
            tIOOpening.mirrorV = this.mMirrorVertical;
        if (this.mMirrorHorizontal)
            tIOOpening.mirrorH = this.mMirrorHorizontal;
        tIOOpening.position = serializeVector2(this.mPosition);
        //if (this.mType == "Door" || this.mType == "DoubleDoor" || this.mType == "Opening") {
        this.mOpeningParams.sill_materialId = this.getMaterialId(this.mMaterial_Sill, false);
        this.mOpeningParams.leaf_materialId = this.getMaterialId(this.mMaterial_Leaf, false);
        this.mOpeningParams.frame_materialId = this.getMaterialId(this.mMaterial_Frame, false);
        this.mOpeningParams.sash_materialId = this.getMaterialId(this.mMaterial_Sash, false);
        this.mOpeningParams.materialSet_Sill = this.mMaterial_Sill;
        this.mOpeningParams.materialSet_Leaf = this.mMaterial_Leaf;
        this.mOpeningParams.materialSet_Frame = this.mMaterial_Frame;
        this.mOpeningParams.materialSet_Sash = this.mMaterial_Sash;
        pContext.addMaterial(this.mOpeningParams.sill_materialId);
        pContext.addMaterial(this.mOpeningParams.leaf_materialId);
        pContext.addMaterial(this.mOpeningParams.frame_materialId);
        pContext.addMaterial(this.mOpeningParams.sash_materialId);
        //}
        //save geometry data
        let tGeomData = this.mGeometry.serializeIOData();
        if (tGeomData != null)
            tIOOpening.geometryData = tGeomData;
        return (tIOOpening);
    }
    /** @internal */
    // tslint:disable-next-line:cyclomatic-complexity
    static _load(pRoomManager, pWall, pIOOpening) {
        if (pIOOpening == null)
            return;
        const tOpeningType = this.determineType(pIOOpening);
        let tOpening = new WallOpening(pRoomManager, tOpeningType);
        let tgeoData = null;
        if (pIOOpening.geometryData !== undefined) {
            tgeoData = pIOOpening.geometryData;
        }
        switch (pIOOpening.type) {
            case "Door":
                tOpening.OpeningParams.doorType = WallOpening.DoorTypes.solid;
                tOpening.OpeningParams.doorTypeDouble = false;
                break;
            case "DoubleDoor":
                tOpening.OpeningParams.doorType = WallOpening.DoorTypes.solid;
                tOpening.OpeningParams.doorTypeDouble = true;
                break;
            case "GlassDoor":
                tOpening.OpeningParams.doorType = WallOpening.DoorTypes.glass;
                tOpening.OpeningParams.doorTypeDouble = false;
                break;
            case "GlassDoubleDoor":
                tOpening.OpeningParams.doorType = WallOpening.DoorTypes.glass;
                tOpening.OpeningParams.doorTypeDouble = true;
                break;
            case "GlassInlayDoor":
                tOpening.OpeningParams.doorType = WallOpening.DoorTypes.inlay;
                tOpening.OpeningParams.doorTypeDouble = false;
                break;
            case "GlassInlayDoubleDoor":
                tOpening.OpeningParams.doorType = WallOpening.DoorTypes.inlay;
                tOpening.OpeningParams.doorTypeDouble = true;
                break;
            case "Window":
                tOpening.OpeningParams.ColumnCount = 1;
                if ((tgeoData != null && tgeoData.ColumnCount !== undefined) &&
                    (tgeoData.glazingBars !== undefined)) {
                    tOpening.OpeningParams.ColumnCount = tgeoData.ColumnCount;
                }
                else if (tgeoData != null && tgeoData.ColumnCount != null) {
                    tgeoData.ColumnCount = 1;
                }
                break;
            case "WindowDouble":
                tOpening.OpeningParams.ColumnCount = 2;
                if (tgeoData != null && tgeoData.ColumnCount !== undefined) {
                    tOpening.mOpeningParams.ColumnCount = tgeoData.ColumnCount;
                }
                break;
            case "GlassFront":
                tOpening.OpeningParams.ColumnCount = 2;
                if (tgeoData != null) {
                    if (tgeoData.ColumnCount !== undefined) {
                        tOpening.mOpeningParams.ColumnCount = tgeoData.ColumnCount;
                    }
                    if (tgeoData.ColumnWidth !== undefined) {
                        tOpening.mOpeningParams.ColumnWidth = tgeoData.ColumnWidth;
                    }
                }
                break;
            default:
                tOpening.OpeningParams.doorType = WallOpening.DoorTypes.solid;
                tOpening.OpeningParams.doorTypeDouble = false;
        }
        if (tgeoData != null) {
            tOpening.mOpeningParams.blindDepth = tgeoData.blindDepth;
            tOpening.mOpeningParams.blindOpeningAngle = tgeoData.blindOpeningAngle;
            tOpening.mOpeningParams.blindOpeningWidth = tgeoData.blindOpeningWidth;
            tOpening.mOpeningParams.blindVisible = tgeoData.blindVisible;
            tOpening.mOpeningParams.privacyFilter = tgeoData.privacyFilter;
            tOpening.mOpeningParams.frameOffset = tgeoData.frameOffset;
            tOpening.mOpeningParams.minWidth = tgeoData.minWidth;
            tOpening.mOpeningParams.openingAngle = tgeoData.openingAngle;
            tOpening.mOpeningParams.fanlight = tgeoData.fanlight;
            tOpening.mOpeningParams.fanlightHeight = tgeoData.fanlightHeight;
            if (tgeoData.doorType !== undefined) {
                tOpening.mOpeningParams.doorType = tgeoData.doorType;
            }
            if (tgeoData.doorTypeDouble !== undefined) {
                tOpening.mOpeningParams.doorTypeDouble = tgeoData.doorTypeDouble;
            }
            if (tgeoData.glazingBars !== undefined) {
                tOpening.mOpeningParams.glazingBars = tgeoData.glazingBars;
            }
            if (tgeoData.glazingBars_h_segments !== undefined) {
                tOpening.mOpeningParams.glazingBars_h_segments = tgeoData.glazingBars_h_segments;
            }
            if (tgeoData.glazingBars_v_segments !== undefined) {
                tOpening.mOpeningParams.glazingBars_v_segments = tgeoData.glazingBars_v_segments;
            }
            if (tgeoData.glazingBars_width !== undefined) {
                tOpening.mOpeningParams.glazingBars_width = tgeoData.glazingBars_width;
            }
            if (tgeoData.sill_materialId !== undefined) {
                tOpening.mOpeningParams.sill_materialId = tgeoData.sill_materialId;
                Util.setMaterialData(tgeoData.sill_materialId, tOpening.MaterialSet_Sill, pRoomManager.materialSplitStr);
            }
            if (tgeoData.leaf_materialId !== undefined) {
                tOpening.mOpeningParams.leaf_materialId = tgeoData.leaf_materialId;
                Util.setMaterialData(tgeoData.leaf_materialId, tOpening.MaterialSet_Leaf, pRoomManager.materialSplitStr);
            }
            if (tgeoData.frame_materialId !== undefined) {
                tOpening.mOpeningParams.frame_materialId = tgeoData.frame_materialId;
                Util.setMaterialData(tgeoData.frame_materialId, tOpening.MaterialSet_Frame, pRoomManager.materialSplitStr);
            }
            if (tgeoData.sash_materialId !== undefined) {
                tOpening.mOpeningParams.sash_materialId = tgeoData.sash_materialId;
                Util.setMaterialData(tgeoData.sash_materialId, tOpening.MaterialSet_Sash, pRoomManager.materialSplitStr);
            }
            tOpening.set_MaterialSet(tOpening.mMaterial_Sill, tOpening.mOpeningParams.materialSet_Sill, tgeoData.materialSet_Sill);
            tOpening.set_MaterialSet(tOpening.mMaterial_Leaf, tOpening.mOpeningParams.materialSet_Leaf, tgeoData.materialSet_Leaf);
            tOpening.set_MaterialSet(tOpening.mMaterial_Frame, tOpening.mOpeningParams.materialSet_Frame, tgeoData.materialSet_Frame);
            tOpening.set_MaterialSet(tOpening.mMaterial_Sash, tOpening.mOpeningParams.materialSet_Sash, tgeoData.materialSet_Sash);
        }
        tOpening.mWidth = pIOOpening.width;
        tOpening.mHeight = pIOOpening.height;
        tOpening.setFloorOffset(pIOOpening.floorOffset, false);
        if (pIOOpening.mirrorV != null)
            tOpening.mMirrorVertical = pIOOpening.mirrorV;
        if (pIOOpening.mirrorH != null)
            tOpening.mMirrorHorizontal = pIOOpening.mirrorH;
        //load geometry datap
        tOpening.geometry.loadIOData(tgeoData);
        tOpening.attachToWall(pWall, deserializeVector2(pIOOpening.position));
        tOpening.updateGeometry();
        pRoomManager.app.model.addElement(tOpening);
    }
    /** @internal */
    _saveUndoData() {
        let tData = {};
        tData.position = this.mPosition.clone();
        tData.width = this.mWidth;
        tData.wall = this.mWall;
        tData.mirrorHorizontal = this.mMirrorHorizontal;
        tData.mirrorVertical = this.mMirrorVertical;
        return (tData);
    }
    /** @internal */
    _loadUndoData(pData) {
        if (pData == null)
            return;
        this.beginGeometryUpdate();
        this.setWidth(pData.width);
        if (pData.wall != null && pData.wall !== this.mWall)
            this.attachToWall(pData.wall, pData.position);
        else
            this.setPosition(pData.position);
        this.setMirrorHorizontal(pData.mirrorHorizontal);
        this.setMirrorVertical(pData.mirrorVertical);
        this.endGeometryUpdate();
    }
    /** @internal */
    // tslint:disable-next-line:cyclomatic-complexity
    _getDistanceEdge(pEdge) {
        if (this.mWall == null || pEdge > 3)
            return (0);
        let tV1 = Vector2.Zero();
        let tV2 = Vector2.Zero();
        let tNRes = this.getNeighbour(pEdge, pEdge === 0 || pEdge === 3); //left/right
        let tNeighbour = tNRes.opening;
        let tWall = tNRes.wall;
        let tDist = 0;
        //use other opening as neighbour
        if (tNeighbour != null && tNeighbour.mWall != null && tWall == null) {
            let tW = this.mWidth;
            if (pEdge === 0 || pEdge === 3) {
                tDist = Vector2.Distance(this.mPosition, this.mWall.startPoint) - tW / 2;
                tDist -= Vector2.Distance(tNeighbour.mPosition, tNeighbour.mWall.startPoint);
                tDist -= tNeighbour.mWidth / 2;
            }
            else {
                tDist = Vector2.Distance(tNeighbour.mPosition, tNeighbour.mWall.startPoint);
                tDist -= tNeighbour.mWidth / 2;
                tDist -= Vector2.Distance(this.mPosition, this.mWall.startPoint) + tW / 2;
            }
        }
        else {
            tV1 = this.getEdge(pEdge, false);
            if (tWall == null) {
                if (tNeighbour == null)
                    tV2 = this.mWall._edges[pEdge];
                else {
                    switch (pEdge) {
                        case 0:
                            tV2 = tNeighbour.getEdge(1, false);
                            break;
                        case 1:
                            tV2 = tNeighbour.getEdge(0, false);
                            break;
                        case 2:
                            tV2 = tNeighbour.getEdge(3, false);
                            break;
                        case 3:
                            tV2 = tNeighbour.getEdge(2, false);
                            break;
                        default:
                            break;
                    }
                }
            }
            else if (pEdge === 0 || pEdge === 2) {
                if (tWall.startCxn.wall === this.mWall)
                    tV2 = tWall._edges[3];
                else
                    tV2 = tWall._edges[1];
            }
            else if (tWall.startCxn.wall === this.mWall)
                tV2 = tWall._edges[0];
            else
                tV2 = tWall._edges[2];
            tDist = Vector2.Distance(tV1, tV2);
            //negate distance if necessary
            if (pEdge === 0 || pEdge === 3) {
                if (!Util.vectorEquals2(this.mWall.endPoint.subtract(this.mWall.startPoint).normalize(), tV1.subtract(tV2).normalize()))
                    tDist *= -1;
            }
            else if (!Util.vectorEquals2(this.mWall.startPoint.subtract(this.mWall.endPoint).normalize(), tV1.subtract(tV2).normalize())) {
                tDist *= -1;
            }
        }
        if (eq(tDist, 0.0))
            tDist = Math.abs(tDist);
        return (tDist);
    }
    /** @internal */
    // tslint:disable-next-line:cyclomatic-complexity
    _update2dVisibility() {
        if (this.mWall === null)
            return;
        let tMeshes = this.m2dGroup.getChildMeshes(false);
        for (let tMesh of tMeshes) {
            if (this.mRoomManager.viewMode === 0 ||
                (this.mRoomManager.visibilityMode === VisibilityMode.Show2d) ||
                (this.mRoomManager.visibilityMode === VisibilityMode.Show3d && this.mWall.isHidden) ||
                (this.mRoomManager.visibilityMode === VisibilityMode.Show3d && this.mRoomManager.isInteracting)) {
                if (this.mWall.keepVisible) {
                    CameraControl.SetMeshCameraModeMask(tMesh, CameraModeMask.Top | CameraModeMask.Bottom);
                }
                else {
                    CameraControl.SetMeshCameraModeMask(tMesh, null);
                }
            }
            else {
                CameraControl.SetMeshCameraModeMask(tMesh, CameraModeMask.Top | CameraModeMask.Bottom);
            }
        }
    }
    /** @internal */
    // tslint:disable-next-line:cyclomatic-complexity
    _update3dVisibility() {
        if (this.mWall === null)
            return;
        if (this.mRoomManager.viewMode === 0 ||
            (this.mRoomManager.visibilityMode === VisibilityMode.Show2d) ||
            (this.mRoomManager.visibilityMode === VisibilityMode.Show3d && this.mWall.isHidden) ||
            (this.mRoomManager.visibilityMode === VisibilityMode.Show3d && this.mRoomManager.isInteracting)) {
            if (this.mWall.keepVisible) {
                this.m3dGroup.setEnabled(true);
            }
            else {
                this.m3dGroup.setEnabled(false);
            }
        }
        else {
            this.m3dGroup.setEnabled(true);
        }
        //update selection bounds
        this.notifyChange(ElementChangedFlags.BoundingBox);
    }
    /** @internal */
    _finishTransformation() {
        if (this.mPendingTransformMatrix == null)
            return;
        if ((this.mWall == null || !this.mRoomManager._wasElementTransformed(this.mWall)) && !this.mwasCloned) {
            let tNewPos = Util.to2d(Vector3.TransformCoordinates(VECTOR3_ZERO, this.mPendingTransformMatrix));
            let tNearest = this.mRoomManager.getNearestWall(tNewPos);
            if (tNearest != null && tNearest !== this.mWall)
                this.attachToWall(tNearest, tNewPos);
            else
                this.setPosition(tNewPos, true);
        }
        if (this.mwasCloned) {
            this.mPendingTransformMatrix = null;
            let tnewPos = this.getFreePosition();
            let tNearest = this.mRoomManager.getNearestWall(tnewPos);
            if (tNearest != null && tNearest !== this.mWall) {
                this.attachToWall(tNearest, tnewPos);
            }
            else {
                //this.setPosition(tnewPos, true);
            }
        }
        this.mPendingTransformMatrix = null;
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    handleImmediateChanges() {
        super.handleImmediateChanges();
        if (this.mWall != null) {
            if (this.wasFlagChanged(ElementChangedFlags.Added))
                this.mWall._addOpening(this);
            if (this.wasFlagChanged(ElementChangedFlags.Removed))
                this.mWall._removeOpening(this);
        }
    }
    handleDelayedChanges() {
        super.handleDelayedChanges();
        if (this.wasFlagChanged(ElementChangedFlags.Transformation) && this.mHandleTansformationChange) {
            if (this.mRoomManager._transformationStarted()) {
                this.mPendingTransformMatrix = this.transform.clone();
                this.mRoomManager._addTransformedElement(this);
            }
            else
                this.updateMatrix(); // reset transform
        }
    }
    copyDataFrom(pElement) {
        super.copyDataFrom(pElement);
        if (pElement == null || !(pElement instanceof WallOpening))
            return;
        let tOther = pElement;
        this.mWidth = tOther.mWidth;
        this.mHeight = tOther.mHeight;
        this.clone_MaterialSet(tOther.mMaterial_Sill, this.mMaterial_Sill);
        this.clone_MaterialSet(tOther.mMaterial_Leaf, this.mMaterial_Leaf);
        this.clone_MaterialSet(tOther.mMaterial_Frame, this.mMaterial_Frame);
        this.clone_MaterialSet(tOther.mMaterial_Sash, this.mMaterial_Sash);
        this.setFloorOffset(tOther.mFloorOffset, false);
        let tData = tOther._saveUndoData();
        this._loadUndoData(tData);
    }
    static determineType(pIOOpening) {
        let tRes = "Door";
        switch (pIOOpening.type) {
            case "Door":
            case "DoubleDoor":
            case "GlassDoor":
            case "GlassDoubleDoor":
            case "GlassInlayDoor":
            case "GlassInlayDoubleDoor":
                tRes = "Door";
                break;
            case "Window":
            case "WindowDouble":
                tRes = "Window";
                break;
            case "Opening":
                tRes = "Opening";
                break;
            case "GlassFront":
                tRes = "GlassFront";
                break;
            default:
                tRes = "Door";
                break;
        }
        return (tRes);
    }
    afterClone(pElement) {
        if (pElement.mWall == null)
            return;
        let tcheck = pElement.mWall.checkInsertWallElement(pElement, true, null, null, true);
        if (!tcheck) {
            pElement.dispose();
            return;
        }
    }
    getScreenScaleFactor() {
        //get screen scale factor
        let tScaleFactor = 1.0;
        let tView = this.mRoomManager.view;
        if (tView != null) {
            let tBBbottom = this.boundingBox.getCenter();
            tBBbottom.y = 0;
            let tDist = tView.projectedDistance(tBBbottom, tBBbottom.add(tView.cameraControl.right.scale(0.1)));
            tScaleFactor *= tDist != null ? 1.0 / tDist : 0.1;
            tScaleFactor *= tView.pixelScaleFactor;
        }
        return tScaleFactor;
    }
    getMaterialId(pMaterial, pCheckMaterial = true) {
        let tRes = this.mRoomManager._wallColors[0];
        let ttmp = pMaterial.category + this.mRoomManager.materialSplitStr + pMaterial.value;
        if (ttmp.indexOf(this.mRoomManager.materialSplitStr) === 0)
            tRes = "color" + this.mRoomManager.materialSplitStr + pMaterial.value;
        else
            tRes = ttmp;
        if (pCheckMaterial)
            this.mRoomManager.checkMaterial(pMaterial);
        return (tRes);
    }
    set_MaterialSet(pOwn, pOpeningParams, pLoaded) {
        if (pLoaded !== undefined) {
            if (pLoaded.category !== undefined)
                pOwn.category = pLoaded.category;
            if (pLoaded.idAddOn !== undefined)
                pOwn.idAddOn = pLoaded.idAddOn;
            if (pLoaded.loadMatId !== undefined)
                pOwn.loadMatId = pLoaded.loadMatId;
            if (pLoaded.rotation !== undefined)
                pOwn.rotation = pLoaded.rotation;
            if (pLoaded.value !== undefined)
                pOwn.value = pLoaded.value;
        }
        pOpeningParams = pOwn;
    }
    clone_MaterialSet(pSourceSet, pDestSet) {
        pDestSet.category = pSourceSet.category;
        pDestSet.idAddOn = pSourceSet.idAddOn;
        pDestSet.loadMatId = pSourceSet.loadMatId;
        pDestSet.rotation = pSourceSet.rotation;
        pDestSet.value = pSourceSet.value;
    }
    cloneOpeningParams(pSourceSet, pDest) {
        pDest.privacyFilter = pSourceSet.privacyFilter;
        pDest.blindVisible = pSourceSet.blindVisible;
        pDest.ColumnCount = pSourceSet.ColumnCount;
        pDest.ColumnWidth = pSourceSet.ColumnWidth;
        pDest.blindDepth = pSourceSet.blindDepth;
        pDest.blindOpeningAngle = pSourceSet.blindOpeningAngle;
        pDest.blindOpeningWidth = pSourceSet.blindOpeningWidth;
        pDest.minWidth = pSourceSet.minWidth;
        pDest.openingAngle = pSourceSet.openingAngle;
        pDest.frameOffset = pSourceSet.frameOffset;
        pDest.windowSill = pSourceSet.windowSill;
        pDest.fanlight = pSourceSet.fanlight;
        pDest.fanlightHeight = pSourceSet.fanlightHeight;
        pDest.doorType = pSourceSet.doorType;
        pDest.doorTypeDouble = pSourceSet.doorTypeDouble;
        pDest.glazingBars = pSourceSet.glazingBars;
        pDest.glazingBars_width = pSourceSet.glazingBars_width;
        pDest.glazingBars_h_segments = pSourceSet.glazingBars_h_segments;
        pDest.glazingBars_v_segments = pSourceSet.glazingBars_v_segments;
    }
    updateWallAttachData() {
        if (this.mWall == null) {
            this.mWallAttachData = null;
            return;
        }
        this.mWallAttachData = {};
        this.mWallAttachData.start = this.mWall.startPoint.clone();
        this.mWallAttachData.end = this.mWall.endPoint.clone();
        this.mWallAttachData.distanceStart = Vector2.Distance(this.mWallAttachData.start, this.mPosition);
        this.mWallAttachData.distanceEnd = Vector2.Distance(this.mWallAttachData.end, this.mPosition);
    }
    updateMatrix() {
        if (this.mWall == null || this.mNode == null)
            return;
        let tWallAngle = this.mWall.getWallAngle();
        this.mNode.rotationQuaternion = Quaternion.RotationAxis(VECTOR3_Y, -tWallAngle);
        this.mNode.position = Util.to3d(this.mPosition);
        this.mHandleTansformationChange = false;
        this.updateTransformation();
        this.mHandleTansformationChange = true;
    }
    getFreePosition() {
        let tRes = this.mPosition.clone();
        if (this.mWallAttachData === null || this.mWall === null)
            return (tRes);
        let twallminEndDist = this.mWall.getWallOpeningsDistanceEnd();
        let twallminStartDist = this.mWall.getWallOpeningsDistanceStart();
        let twallDirection = this.mWall.wallDirection.clone().normalize();
        let tendDistance = twallminEndDist - (this.mWidth);
        let tstartDistance = twallminStartDist - (this.mWidth);
        if (tendDistance > 0) {
            let tOffset = twallminEndDist - (this.mWidth * 0.5) - 0.06;
            tRes = this.mWallAttachData.end.subtract(twallDirection.scale(tOffset));
        }
        else if (tstartDistance > 0) {
            let tOffset = twallminStartDist - (this.mWidth * 0.5) - 0.06;
            tRes = this.mWallAttachData.start.add(twallDirection.scale(tOffset));
        }
        return (tRes);
    }
    setHeight(pValue) {
        let tValue = clamp(pValue, 0.01, 100.0);
        if (eq(this.mHeight, tValue))
            return (false);
        this.mHeight = tValue;
        this.beginChange();
        this.updateGeometry();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        this.endChange();
        if (this.mWall != null)
            this.mWall.updateGeometry();
        this.mRoomManager.contentChanged();
        return (true);
    }
    setFloorOffset(pValue, pNotifyChange) {
        let tValue = clamp(pValue, 0.0, 100.0);
        if (eq(this.mFloorOffset, tValue))
            return;
        this.mFloorOffset = tValue;
        this.m3dGroup.position.y = this.mFloorOffset;
        this.updateGeometry();
        if (pNotifyChange) {
            this.notifyChange(ElementChangedFlags.PropertyValues |
                ElementChangedFlags.BoundingBox);
            if (this.mWall != null)
                this.mWall.updateGeometry();
        }
        this.mRoomManager.contentChanged();
    }
    setHandleHeight(pValue) {
        let tValue = clamp(pValue, 0.05, this.mHeight - 0.05);
        if (eq(this.mHandleHeight, tValue))
            return;
        this.mHandleHeight = tValue;
        this.notifyChange(ElementChangedFlags.PropertyValues);
        this.updateGeometry();
        this.mRoomManager.contentChanged();
    }
    setFanLightEnabled(pActive) {
        this.mOpeningParams.fanlight = pActive;
        this.notifyChange(ElementChangedFlags.Properties);
        this.updateGeometry();
        this.mRoomManager.contentChanged();
    }
    setDoorType(pDoorType, pDoorDouble) {
        let tdoorType = WallOpening.DoorTypes.solid;
        switch (pDoorType) {
            case "solid":
                tdoorType = WallOpening.DoorTypes.solid;
                this.mOpeningParams.doorTypeDouble = pDoorDouble;
                break;
            case "inlay":
                tdoorType = WallOpening.DoorTypes.inlay;
                this.mOpeningParams.doorTypeDouble = pDoorDouble;
                break;
            case "glass":
                tdoorType = WallOpening.DoorTypes.glass;
                this.mOpeningParams.doorTypeDouble = pDoorDouble;
                break;
            default:
                tdoorType = WallOpening.DoorTypes.solid;
                this.mOpeningParams.doorTypeDouble = pDoorDouble;
                break;
        }
        this.mOpeningParams.doorType = tdoorType;
        this.notifyChange(ElementChangedFlags.Properties);
        this.updateGeometry();
        this.mRoomManager.contentChanged();
    }
    setFanLightHeight(pValue) {
        let tValue = clamp(pValue, 0.15, this.mHeight - 0.15);
        if (eq(this.mOpeningParams.fanlightHeight, tValue))
            return;
        this.mOpeningParams.fanlightHeight = tValue;
        this.notifyChange(ElementChangedFlags.PropertyValues);
        this.updateGeometry();
        this.mRoomManager.contentChanged();
    }
    setOpeningAngle(pValue, pNotifyChange = true) {
        let topeningAngle = this.mOpeningParams.openingAngle !== undefined ? this.mOpeningParams.openingAngle : 0;
        let tValue = clamp(pValue, 0.0, 160.0);
        if (eq(topeningAngle, tValue))
            return;
        this.mOpeningParams.openingAngle = tValue;
        this.updateGeometry();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        this.notifyChange(ElementChangedFlags.Properties);
        this.mRoomManager.contentChanged();
    }
    setMaterialCategory(pValue, pMatOfCat = "", pMaterial, pforceSet = false) {
        pMaterial.category = pValue === "color" ? "" : pValue;
        // clear loaded material id
        pMaterial.loadMatId = "";
        let t1stMatOfCat = pMatOfCat;
        if (t1stMatOfCat === "") {
            t1stMatOfCat = this.mRoomManager._getFirstextMaterialOfCategory(pValue);
        }
        pMaterial.value = t1stMatOfCat;
        this.mRoomManager.checkMaterial(pMaterial).then((pResult) => {
            if (pResult === 1 || pResult === 2) {
                this.updateGeometry();
                this.notifyChange(ElementChangedFlags.PropertyValues);
                this.notifyChange(ElementChangedFlags.Properties);
            }
        });
        return (true);
    }
    setMaterial_Sill(pValue, pMaterial) {
        let tmatValue = StringProperty.ConvertValueToString(pValue);
        if (tmatValue.trim() === "") {
            pMaterial.value = "";
            // clear loaded material id
            pMaterial.loadMatId = "";
            return (false);
        }
        // clear loaded material id
        pMaterial.loadMatId = "";
        let tmatGroup = tmatValue.split(this.mRoomManager.materialSplitStr);
        if (tmatGroup !== undefined) {
            if (tmatGroup.length === 1) {
                tmatValue = tmatGroup[0];
                this.mDoorSillColor = tmatValue;
            }
            if (tmatGroup.length > 1) {
                tmatValue = tmatGroup[1];
            }
        }
        else {
            tmatValue = "";
        }
        pMaterial.value = tmatValue;
        this.mRoomManager.checkMaterial(pMaterial).then((pResult) => {
            if (pResult === 1 || pResult === 2) {
                this.updateGeometry();
                this.notifyChange(ElementChangedFlags.PropertyValues);
            }
        });
        return (true);
    }
    setMaterial_Leaf(pValue, pMaterial) {
        let tmatValue = StringProperty.ConvertValueToString(pValue);
        if (tmatValue.trim() === "") {
            pMaterial.value = "";
            // clear loaded material id
            pMaterial.loadMatId = "";
            return (false);
        }
        // clear loaded material id
        pMaterial.loadMatId = "";
        let tmatGroup = tmatValue.split(this.mRoomManager.materialSplitStr);
        if (tmatGroup !== undefined) {
            if (tmatGroup.length === 1) {
                tmatValue = tmatGroup[0];
                this.mDoorLeafColor = tmatValue;
            }
            if (tmatGroup.length > 1) {
                tmatValue = tmatGroup[1];
            }
        }
        else {
            tmatValue = "";
        }
        pMaterial.value = tmatValue;
        this.mRoomManager.checkMaterial(pMaterial).then((pResult) => {
            if (pResult === 1 || pResult === 2) {
                this.updateGeometry();
                this.notifyChange(ElementChangedFlags.PropertyValues);
            }
        });
        return (true);
    }
    setMaterial_Leaf_complete(pMaterialSet) {
        this.mMaterial_Leaf.category = pMaterialSet.category;
        this.mMaterial_Leaf.rotation = pMaterialSet.rotation;
        this.mMaterial_Leaf.value = pMaterialSet.value;
    }
    setMaterial_Frame(pValue, pMaterial) {
        let tmatValue = StringProperty.ConvertValueToString(pValue);
        if (tmatValue.trim() === "") {
            pMaterial.value = "";
            // clear loaded material id
            pMaterial.loadMatId = "";
            return (false);
        }
        // clear loaded material id
        pMaterial.loadMatId = "";
        let tmatGroup = tmatValue.split(this.mRoomManager.materialSplitStr);
        if (tmatGroup !== undefined) {
            if (tmatGroup.length === 1) {
                tmatValue = tmatGroup[0];
                this.mDoorLeafColor = tmatValue;
            }
            if (tmatGroup.length > 1) {
                tmatValue = tmatGroup[1];
            }
        }
        else {
            tmatValue = "";
        }
        pMaterial.value = tmatValue;
        this.mRoomManager.checkMaterial(pMaterial).then((pResult) => {
            if (pResult === 1 || pResult === 2) {
                this.updateGeometry();
                this.notifyChange(ElementChangedFlags.PropertyValues);
            }
        });
        return (true);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getNeighbour(pEdge, pLeft) {
        let tRes = {
            wall: null,
            opening: null
        };
        if (this.mWall == null)
            return (tRes);
        let tWallOpenings = arrClone(this.mWall.openings);
        //remove openings that are not on the same height level
        let tLow1 = this.mFloorOffset;
        let tHigh1 = this.mFloorOffset + this.mHeight;
        let i = 0;
        while (i < tWallOpenings.length) {
            let tLow2 = tWallOpenings[i].mFloorOffset;
            let tHigh2 = tWallOpenings[i].mFloorOffset + tWallOpenings[i].mHeight;
            if (tWallOpenings[i] !== this && (tHigh2 < tLow1 || tLow2 > tHigh1)) {
                tWallOpenings.splice(i, 1); //remove
            }
            else
                ++i;
        }
        // this can only happen if this is not yet added to the opening list of mWall
        if (tWallOpenings.length === 0)
            return (tRes);
        tWallOpenings.sort(WallOpening.cmpWallElements);
        //find neighbour openings
        if (pLeft) {
            if (tWallOpenings[0] !== this) {
                for (let i1 = 0; i1 < tWallOpenings.length; ++i1) {
                    if (tWallOpenings[i1] === this) {
                        tRes.opening = tWallOpenings[i1 - 1];
                        break;
                    }
                }
            }
        }
        else if (tWallOpenings[tWallOpenings.length - 1] !== this) {
            for (let i2 = 0; i2 < tWallOpenings.length; ++i2) {
                if (tWallOpenings[i2] === this) {
                    tRes.opening = tWallOpenings[i2 + 1];
                    break;
                }
            }
        }
        //find neighbour wall
        let tWalls = new Array();
        let tTempWalls = new Array();
        if (pEdge === 0 || pEdge === 1) {
            this.mWall.getAllSideWalls(tTempWalls, tWalls, true, true);
        }
        else
            this.mWall.getAllSideWalls(tWalls, tTempWalls, true, true);
        if (pLeft)
            tWalls.reverse();
        let tVS = this.mWall.startPoint;
        let tV;
        let tDist = Vector2.Distance(this.mPosition, tVS);
        let tDist1 = 0;
        let tDist2 = 0;
        if (tRes.opening != null)
            tDist1 = Vector2.Distance(tRes.opening.mPosition, tVS);
        for (let tWall of tWalls) {
            if (tWall.startCxn.wall === this.mWall)
                tV = tWall.startPoint;
            else
                tV = tWall.endPoint;
            tDist2 = Vector2.Distance(tV, tVS);
            if (pLeft) {
                if ((tDist2 < tDist) && (tRes.opening == null || tDist1 < tDist2)) {
                    tRes.wall = tWall;
                    break;
                }
            }
            else if ((tDist2 > tDist) && (tRes.opening == null || tDist1 > tDist2)) {
                tRes.wall = tWall;
                break;
            }
        }
        return (tRes);
    }
    update2dGeometry() {
        //dispose current geometries
        let t2dNodes = this.m2dGroup.getChildTransformNodes(true);
        for (let tNode of t2dNodes)
            tNode.dispose();
        this.createBase2dGeometry();
        this.mGeometry.create2dGeometry(this.m2dGroup);
        this._update2dVisibility();
    }
    update3dGeometry() {
        //dispose current geometries
        let t3dNodes = this.m3dGroup.getChildTransformNodes(true);
        for (let tNode of t3dNodes)
            tNode.dispose();
        this.createBase3dGeometry();
        this.mGeometry.create3dGeometry(this.m3dGroup);
        this._update3dVisibility();
    }
    createBase2dGeometry() {
        let tHW = this.mWidth * 0.5;
        let tHD = this.depth * 0.5;
        let tLines = CreateLines("", {
            points: [
                new Vector3(-tHW, 0.0, -tHD),
                new Vector3(-tHW, 0.0, tHD),
                new Vector3(tHW, 0.0, tHD),
                new Vector3(tHW, 0.0, -tHD),
                new Vector3(-tHW, 0.0, -tHD)
            ],
            updatable: false,
            instance: null
        }, this.mScene);
        tLines.isPickable = false;
        tLines.intersectionThreshold = 0;
        tLines.color = Color3.Black();
        tLines.position.y = WallOpening.WALLOPENING_2D_BASE_HEIGHT;
        tLines.parent = this.m2dGroup;
        tLines.freezeWorldMatrix();
        let tPlane = CreatePlane("", { width: this.mWidth, height: this.depth }, this.mScene);
        tPlane.rotation.x = PI_DIV2;
        tPlane.parent = this.m2dGroup;
        tPlane.material = this.mModel.materials.defaultMaterial;
        tPlane.position.y = WallOpening.WALLOPENING_2D_BASE_HEIGHT;
        tPlane.isPickable = true;
        if (this.misInteracting)
            tPlane.visibility = 0.5;
        else
            tPlane.visibility = 1;
        tPlane.freezeWorldMatrix();
        ShadowGenerator.disableMeshShadow(tPlane);
    }
    createBase3dGeometry() {
        if (this.mFloorOffset !== 0 || (this.mType === "Window" || this.mType === "WindowDouble"))
            return;
        // door sill
        let tsillMaterial = this.getMaterialId(this.mMaterial_Sill);
        let tMat = null;
        if (tsillMaterial.indexOf(this.mRoomManager.materialSplitStr) === -1) {
            tMat = this.mRoomManager._getWallColorMaterial(this.mMaterial_Sill.value);
        }
        else {
            tMat = this.mRoomManager.MatManager.getMaterial(tsillMaterial);
        }
        let tEntryPlane = this.createCSG(this.m3dGroup);
        if (tEntryPlane == null)
            return;
        tEntryPlane.parent = this.m3dGroup;
        if (this.wall != null)
            tEntryPlane.name = "room:wall|" + this.wall.id.toString();
        tEntryPlane.visibility = 1.0;
        tEntryPlane.position.y = 0;
        if (tMat != null)
            tEntryPlane.material = tMat;
        this.prepare3dMesh(tEntryPlane);
    }
    createCSG(pParent) {
        let tOWH = this.mWidth * 0.5;
        let tODH = this.depth * 0.5;
        let tPoints = new Array();
        tPoints.push(new CSG.Vector2D(tOWH, tODH));
        tPoints.push(new CSG.Vector2D(-tOWH, tODH));
        tPoints.push(new CSG.Vector2D(-tOWH, -tODH));
        tPoints.push(new CSG.Vector2D(tOWH, -tODH));
        let tCAGshape = CAG.fromPointsNoCheck(tPoints);
        if (tCAGshape.isSelfIntersecting())
            return (null);
        let tMesh = Util.buildMeshOfCAG(tCAGshape, this.mScene);
        return (tMesh);
    }
    prepare3dMesh(pMesh) {
        if (pMesh == null)
            return;
        pMesh.freezeWorldMatrix();
        //not visible in top and bottom view
        CameraControl.SetMeshCameraModeMask(pMesh, CameraModeMask.All &
            ~CameraModeMask.Top & ~CameraModeMask.Bottom);
    }
    static cmpWallElements(pW1, pW2) {
        if (pW1.mWall != null && pW2.mWall != null) {
            let tL1 = Vector2.Distance(pW1.mPosition, pW1.mWall.startPoint);
            let tL2 = Vector2.Distance(pW2.mPosition, pW2.mWall.startPoint);
            return (tL1 - tL2);
        }
        return (0);
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
WallOpening.PROP_KEY_DOOR_TYPE = "room:WallOpening:doorType";
WallOpening.PROP_KEY_DOOR_LEAF_COUNT = "room:WallOpening:doorLeafCount";
WallOpening.PROP_KEY_WIDTH = "room:WallOpening:width";
WallOpening.PROP_KEY_HEIGHT = "room:WallOpening:height";
WallOpening.PROP_KEY_FLOOROFFSET = "room:WallOpening:floorOffset";
WallOpening.PROP_KEY_HANDLEHEIGHT = "room:WallOpening:handleHeight";
WallOpening.PROP_KEY_FANLIGHTENABLED = "room:WallOpening:fanLightEnabled";
WallOpening.PROP_KEY_FANLIGHTHEIGHT = "room:WallOpening:fanLightHeight";
WallOpening.PROP_KEY_OPENINGANGLE = "room:WallOpening:openingAngle";
WallOpening.PROP_KEY_COLOR_SILL = "room:WallOpening:color:sill";
WallOpening.PROP_KEY_MATCAT_SILL = "room:WallOpening:matCat:sill";
WallOpening.PROP_KEY_COLOR_LEAF = "room:WallOpening:color:leaf";
WallOpening.PROP_KEY_MATCAT_LEAF = "room:WallOpening:matCat:leaf";
WallOpening.PROP_KEY_COLOR_FRAME = "room:WallOpening:color:frame";
WallOpening.PROP_KEY_MATCAT_FRAME = "room:WallOpening:matCat:frame";
WallOpening.PROP_KEY_COLOR_WINDOWSASH = "room:WallOpening:color:windowSash";
WallOpening.PROP_KEY_MATCAT_WINDOWSASH = "room:WallOpening:matCat:windowSash";
WallOpening.WALLOPENING_2D_BASE_HEIGHT = 0.0005;
//add nested types
(function (WallOpening) {
    let DoorTypes;
    (function (DoorTypes) {
        DoorTypes["solid"] = "solid";
        DoorTypes["inlay"] = "inlay";
        DoorTypes["glass"] = "glass";
    })(DoorTypes = WallOpening.DoorTypes || (WallOpening.DoorTypes = {}));
})(WallOpening || (WallOpening = {}));
